import axios from "axios";
import { v4 as uuidv4 } from 'uuid'
const apiClient = axios.create({
  baseURL: `https://api-gameplex.bharat-techsolutions.com/`,
  // baseURL: `https://gameplex.bharat-techsolutions.com/`,
  // Note: If you are strictly using localStorage for auth and no longer rely on cookies at all, 
  // you can safely remove `withCredentials: true`. 
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request Interceptor: Automatically attach JWT from localStorage if it exists
apiClient.interceptors.request.use((config) => {
  // 1. Grab the token directly from local storage
  const jwt = localStorage.getItem("jwt");
  
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
}, (error) => Promise.reject(error));

// Response Interceptor: Global error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 2. Clear the invalid/expired token from local storage
      localStorage.removeItem("jwt");
      
      // 3. Redirect to login
      window.location.href = `/login?ext_id=${uuidv4()}`;
    }
    if(localStorage.getItem("jwt")==null){
       window.location.href = `/login?ext_id=${uuidv4()}`;
    }
    return Promise.reject(error);
  }
);

// --- API Methods ---

export const fetchGamesApi = () => apiClient.get('api/games');


export const unsubApi = () => apiClient.post('api/un-subscription');


export const requestOtpApi = (msisdn, packName) => 
  apiClient.post('api/send-otp', { msisdn, packName });

export const checkUserApi = (msisdn) => 
  apiClient.post('api/check-user', { msisdn });

export const verifyOtpApi = (msisdn, packName, price, otpString, token,ext_ref) => 
  apiClient.post('api/validate-otp', { msisdn, packName, price, otpString, token,ext_ref });